import { render, staticRenderFns } from "./UserKeysTab.vue?vue&type=template&id=18c186f6&"
import script from "./UserKeysTab.vue?vue&type=script&lang=ts&"
export * from "./UserKeysTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports